export default "__VITE_ASSET__BkxhJ26s__"